import { matchPath } from 'react-router-dom';

import { ROUTER_PATHS } from 'src/paths';
import type { ConfigStateContext } from 'src/types';
export type PageName =
  | 'CommunityGroupDetails'
  | 'CommunityAllGroups'
  | 'CommunityTopGroups'
  | 'CommunityMyGroups'
  | 'CommunityThreadDetails'
  | 'CommunityHome'
  | 'unknown';

export const getSearchParam = (search: string, key: string): string => {
  const searchParams = new URLSearchParams(search);
  return searchParams.get(key) || '';
};

export const getPageName = (path: string): PageName => {
  const pathName = path.split('?')[0].split('#')[0];
  const searchParams = new URLSearchParams(`?${path.split('?')?.[1]}` || '');
  if (
    matchPath(ROUTER_PATHS.communityGroupsDetails, pathName) ||
    matchPath(ROUTER_PATHS.languageCommunityGroupsDetails, pathName)
  ) {
    return 'CommunityGroupDetails';
  } else if (
    matchPath(ROUTER_PATHS.communityGroups, pathName) ||
    matchPath(ROUTER_PATHS.languageCommunityGroups, pathName)
  ) {
    if (searchParams.get('type') === 'top-groups') {
      return 'CommunityTopGroups';
    }
    if (searchParams.get('type') === 'my-groups') {
      return 'CommunityMyGroups';
    }
    return 'CommunityAllGroups';
  } else if (
    // TODO: remove this when melways is merged and new path is ready
    matchPath(ROUTER_PATHS.communityThreadDetails, pathName) ||
    matchPath(ROUTER_PATHS.languageCommunityThreadDetails, pathName)
  ) {
    return 'CommunityThreadDetails';
  } else if (
    matchPath(ROUTER_PATHS.communityThreadDetail, pathName) ||
    matchPath(ROUTER_PATHS.languageCommunityThreadDetail, pathName)
  ) {
    return 'CommunityThreadDetails';
  } else if (
    matchPath(ROUTER_PATHS.communityHome, pathName) ||
    matchPath(ROUTER_PATHS.languageCommunityHome, pathName)
  ) {
    return 'CommunityHome';
  }
  return 'unknown';
};

export const getPageNumber = (search: string): number => {
  const pageSearchParams = new URLSearchParams(search);
  const page = pageSearchParams.get('page') || '1';
  return parseInt(page, 10);
};

export const getPageAnalyticsName = (
  pageName: PageName,
): string | undefined => {
  switch (pageName) {
    case 'CommunityGroupDetails':
      return 'seekmax category';
    case 'CommunityAllGroups':
      return 'discover groups';
    case 'CommunityThreadDetails':
      return 'seekmax view thread';
    case 'CommunityHome':
      return 'seekmax home';
    default:
      return undefined;
  }
};

export const getPageSlug = (
  pageName: PageName,
  params: Record<string, string | undefined>,
): string => {
  if (pageName === 'CommunityGroupDetails' && params.groupSlug) {
    return params?.groupSlug?.split('-')?.slice(0, -1).join('-') || '';
  }
  if (pageName === 'CommunityThreadDetails' && params.threadSlug) {
    return params?.threadSlug?.split('-')?.slice(0, -1).join('-') || '';
  }
  return '';
};

export const getCurrentPageNumber = (
  config: Pick<ConfigStateContext, 'absoluteUrl'>,
): number => {
  const isServer = typeof window === 'undefined';
  if (isServer) {
    return getPageNumber(new URL(config.absoluteUrl).search);
  }
  return getPageNumber(window.location.search);
};
